import Text from '../entities/text';

const textDataTransformationAfterFetch = (data) => {
    return data.map((row) => {
        return new Text(row);
    });
};

export default textDataTransformationAfterFetch;
